/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/social-export-api-client";
import type { SettingsUpdateConnectionMutationRequest, SettingsUpdateConnectionMutationResponse, SettingsUpdateConnectionPathParams } from "../models/SettingsUpdateConnection";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { settingsUpdateConnection } from "../axios/settingsUpdateConnection";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const settingsUpdateConnectionMutationKey = () => ["social-export-api", { url: '/connections/:station/:platform/settings' }] as const

export type SettingsUpdateConnectionMutationKey = ReturnType<typeof settingsUpdateConnectionMutationKey>

export function settingsUpdateConnectionMutationOptions<TContext = unknown>(config: Partial<RequestConfig<SettingsUpdateConnectionMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = settingsUpdateConnectionMutationKey()
        return mutationOptions<SettingsUpdateConnectionMutationResponse, ResponseErrorConfig<Error>, {station: SettingsUpdateConnectionPathParams["station"], platform: SettingsUpdateConnectionPathParams["platform"], data: SettingsUpdateConnectionMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ station, platform, data }) => {
            return settingsUpdateConnection(station, platform, data, config)
          },
        })

}

/**
 * @description Updates the connection settings for a specific platform. Settings structure varies by platform.
 * @summary Update connection settings for a station
 * {@link /connections/:station/:platform/settings}
 */
export function useSettingsUpdateConnection<TContext>(options: 
{
  mutation?: UseMutationOptions<SettingsUpdateConnectionMutationResponse, ResponseErrorConfig<Error>, {station: SettingsUpdateConnectionPathParams["station"], platform: SettingsUpdateConnectionPathParams["platform"], data: SettingsUpdateConnectionMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<SettingsUpdateConnectionMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? settingsUpdateConnectionMutationKey()

          const baseOptions = settingsUpdateConnectionMutationOptions(config) as UseMutationOptions<SettingsUpdateConnectionMutationResponse, ResponseErrorConfig<Error>, {station: SettingsUpdateConnectionPathParams["station"], platform: SettingsUpdateConnectionPathParams["platform"], data: SettingsUpdateConnectionMutationRequest}, TContext>
          

          return useMutation<SettingsUpdateConnectionMutationResponse, ResponseErrorConfig<Error>, {station: SettingsUpdateConnectionPathParams["station"], platform: SettingsUpdateConnectionPathParams["platform"], data: SettingsUpdateConnectionMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<SettingsUpdateConnectionMutationResponse, ResponseErrorConfig<Error>, {station: SettingsUpdateConnectionPathParams["station"], platform: SettingsUpdateConnectionPathParams["platform"], data: SettingsUpdateConnectionMutationRequest}, TContext>
      
}